export default {
      id: "arrow-up-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-up-right",
      toString: function () {
        return this.url;
      }
    }